import React from 'react';

import './Card28.css';

const Card28 = props => {
  return (
    <div className={`card28 ${props.className}`} style={props.style}>
      {props.children}
    </div>
  );
};

export default Card28;
